import React from 'react';
import { useContext, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import ClienteDialogForm from '../../forms/clienteForm';
import loading from '../../../img/seguros_ok_loading.svg';

//styles
import useStyles from './styles'

//Context
import { ClientesContext } from './context';
import { APIContext } from '../../../context';

const ClientesView = () => {

  const classes = useStyles();
  const { editableObject, dialogOpen, handleDialogClose, options, columns} = useContext(ClientesContext);

  const { clientes, 
    listClientesFull, 
    listClientesCotizacion ,
    loading_img
  } = useContext(APIContext);
    
  useEffect(() => {
    let asesor = "";
    let userLogged = JSON.parse(localStorage.getItem('user'))
    let rol = 2
    
    if (userLogged.ase_rol > rol){
      asesor = userLogged.id
      listClientesCotizacion(asesor);
    }else{
      listClientesFull()
    }
  }, []);

  return (
    <div className={classes.root} >
      <CssBaseline />

      <main className={classes.content}>

        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              <ClienteDialogForm dialogOpen={dialogOpen} handleClose={handleDialogClose} array={[editableObject]} edit={true} />
              {!loading_img ? (
                <MUIDataTable
                  title={"Clientes"}
                  data={clientes}
                  columns={columns}
                  options={options}
                />
              ) : (
                <div className="loading_container">
                  <img src={loading} className="loading" alt="cargando..." />
                </div>
                
              )}
            </Grid>
          </Grid>
        </Container>
      </main>
    </div >
  );
  //}
}
export default ClientesView;